import script from "./SelectedBonuses.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedBonuses.vue?vue&type=script&setup=true&lang=ts"

import "./SelectedBonuses.vue?vue&type=style&index=0&id=1acc74a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acc74a4"]])

export default __exports__